const Loading = () => {
  return (
    <div className="h-screen ">
      <div className="flex justify-center items-center h-full">
        <div className="w-16 h-16 border-b-4 border-black rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default Loading;
